import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, StyledSpinner } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledTasksHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1.6rem;
`;
export const StyledHeaderHeadingWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
`;

export const StyledTaskHeaderHeading = styled.span`
  font-size: 2.4rem;
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledTaskIcon = styled(FontAwesomeIcon)`
  font-size: 2.4rem;
  color: ${({ theme }) => theme.colors.info.main};
`;

export const StyledTaskHeaderOptionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const StyledHeaderOptionButton = styled(Button)`
  background-color: ${({ theme }) => theme.colors.background.secondary};
  &&:hover {
    svg {
      color: ${({ theme }) => theme.colors.black};
    }
  }
`;

export const StyledOptionButtonIcon = styled(FontAwesomeIcon)`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledTasksContentContainer = styled.div`
  margin-top: 2.4rem;
  margin-bottom: 2.4rem;
`;

export const StyledTaskOptionsButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1.6rem;
`;

export const StyledLoadingSpinner = styled(StyledSpinner)`
  margin-right: 0.5rem;
`;
